export const getConfigurationSettings = (state) => state.configurationSettings.settings || [];
export const getUpdateConfigurationSettingsSuccess = (state) => state.configurationSettings.updateSuccess;
